import type { ReadingListMenuSignature } from '@efdigital/ll-addon-content/types/components/parts/reading-list-menu';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

const ReadingListMenu: TemplateOnlyComponent<ReadingListMenuSignature> =
  <template></template>;

export { ReadingListMenu };
